import { Box, Button, Paper, Tab, Tabs } from '@mui/material';
import React from 'react';
import ChatIcon from '@mui/icons-material/ForumRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import ChatBody from './ChatBody';

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function Chat({ tabs, btnLabel, tabIcon }) {
  const [chatOn, setChatOn] = React.useState(false);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      {chatOn ? (
        <Paper
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: '50%',
            height: '50%',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderTopLeftRadius: '7px',
            borderTopRightRadius: '7px',
            border: '1px solid #ccc',
            borderBottom: 'none',
          }}
        >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{
              borderRight: 1,
              borderColor: 'divider',
              width: '17.5%',
              height: '100%',
              backgroundColor: 'hsla(250, 86%, 97%, 1)',
            }}
          >
            {tabs.map((tab) => (
              <Tab
                label={tab.label}
                {...a11yProps(0)}
                icon={tabIcon}
                iconPosition="start"
              />
            ))}
          </Tabs>
          {/* Tab panels */}
          {tabs.map((tab, index) => (
            <TabPanel value={value} index={index}>
              <ChatBody msgs={tab.panelMsgs} />
            </TabPanel>
          ))}

          <ChatBtn
            setChatOn={setChatOn}
            setOnClick={false}
            label="Close Chat"
            icon={<CloseIcon />}
          />
        </Paper>
      ) : (
        <ChatBtn
          setChatOn={setChatOn}
          setOnClick={true}
          label={btnLabel}
          icon={<ChatIcon />}
        />
      )}
    </>
  );
}

const ChatBtn = ({ setChatOn, setOnClick, label, icon }) => {
  return (
    <Box sx={{ position: 'absolute', bottom: 5, right: 5, zIndex: 6 }}>
      <Button
        variant="contained"
        endIcon={icon}
        onClick={() => {
          setChatOn(setOnClick);
        }}
      >
        {label}
      </Button>
    </Box>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: 0,
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: '82.5%',
            height: '100%',
            overflow: 'auto',
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}
